function getMinutesLimitStart(minutes) {
    if (minutes > 0 && minutes <= 15) {
        return 15;
    } else if (minutes > 15 && minutes <= 30) {
        return 30;
    } else if (minutes > 30 && minutes <= 45) {
        return 45;
    }
    return 0;
}

function getMinutesLimitEnd(minutes) {
    if (minutes > 0 && minutes <= 15) {
        return 14;
    } else if (minutes > 15 && minutes <= 30) {
        return 29;
    } else if (minutes > 30 && minutes <= 45) {
        return 44;
    }
    return 59;
}

export default {
    bytesToSize: (bytes, decimals) => {
        const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'];
        if (bytes === 0) {
            return '0B';
        }
        if (bytes < 1) {
            return bytes;
        }
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
        if (decimals === 0) {
            return (`${Math.round((bytes / Math.pow(1024, i)))} ${sizes[i]}`);
        }
        return (`${parseFloat(bytes / Math.pow(1024, i))
          .toFixed(decimals || 2)} ${sizes[i]}`);
    },
    gibibytesToBytes: gibibytes => gibibytes * 1024 * 1024 * 1024,
    momentToStart: moment => {
        moment.milliseconds(0);
        moment.seconds(0);
        moment.minutes(getMinutesLimitStart(moment.minutes()));
        return moment;
    },
    momentToEnd: moment => {
        if (moment.minutes() === 0) {
            moment.subtract(1, 'hours');
            moment.minutes(59);
        }
        moment.milliseconds(999);
        moment.seconds(59);
        moment.minutes(getMinutesLimitEnd(moment.minutes()));
        return moment;
    },
};



/** WEBPACK FOOTER **
 ** ./src/utils/metricsTools.js
 **/